// utils/eventBus.js
class EventBus {
    constructor() {
      this.events = {} // 存储事件
    }
  
    // 监听事件
    $on(eventName, callback) {
      if (!this.events[eventName]) {
        this.events[eventName] = []
      }
      this.events[eventName].push(callback)
    }
  
    // 触发事件
    $emit(eventName, ...args) {
      if (this.events[eventName]) {
        this.events[eventName].forEach(cb => cb(...args))
      }
    }
  
    // 移除事件
    $off(eventName, callback) {
      if (!this.events[eventName]) return
  
      if (!callback) {
        // 如果没有传入 callback，则移除该事件的所有监听
        delete this.events[eventName]
      } else {
        // 移除指定的 callback
        this.events[eventName] = this.events[eventName].filter(cb => cb !== callback)
      }
    }
  }
  
  // 导出一个全局单例
  export default new EventBus()